<template>
  <div>
    <template v-if="getDateFormattedCard">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 100%"
      />
      <v-divider class="mt-10" />
    </template>
    <v-data-table
      class="mb-0 style-table-arquivos-dados"
      :headers="headers"
      :items="_items"
      :search.sync="search"
      :headerProps="{ sortByText: 'Ordenar Por' }"
      :footer-props="{ itemsPerPageText: 'Itens por Página' }"
      no-data-text="Nenhum arquivo encontrado"
      no-results-text="Nenhum registro correspondente encontrado"
      mobile-breakpoint="920"
      :hide-default-footer="loading"
      :hide-default-header="loading"
      :loading="loading"
      loading-text="Carregando arquivos ..."
    >
      <template v-slot:[`item.nome`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" class="text-truncate-column" v-on="on">
              <a href="javascript:void(0)" @click="downloadFile(item)">{{ item.nome }}</a>
              <v-btn
                v-if="_downloadProgressData[item.id] !== undefined ? true : false"
                color="gray"
                class="mb-2 ml-2"
                fab
                icon
                height="18"
                width="18"
                :loading="true"
              />
            </div>
          </template>
          <span>Baixar Arquivo -> {{ item.nome }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.size`]="{ item }">
        {{ item.size | bytesToSize }}
      </template>
      <template v-slot:[`item.importado`]="{ item }">
        <span class="font-weight-medium" :style="{ color: item.importado ? 'green' : 'red' }">
          <v-icon x-small class="pb-1" v-text="item.importado ? 'mdi-thumb-up-outline' : 'mdi-thumb-down-outline'" />
          {{ item.importado ? 'Sim' : 'Não' }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          id="action-edit-arquivos-dados"
          :loading="_downloadProgressData[item.id] != undefined"
          min-width="0"
          class="ml-n1 px-1"
          fab
          icon
          x-small
          @click="downloadFile(item)"
        >
          <v-icon small>mdi-download</v-icon>
        </v-btn>
        <v-menu v-if="userIsAdmin || user.id_hexa === item.usuario_id" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="action-more-arquivos-dados"
              color="white"
              class="ml-1"
              height="22px"
              width="22px"
              fab
              x-small
              elevation="1"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="userIsAdmin || user.id_hexa === item.usuario_id" @click="openDialogDelete(item.id, item.nome)">
              <v-list-item-icon class="mx-0 my-0 py-4">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Deletar</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!item.importado && userIsAdmin" @click="setImportado(item.id)">
              <v-list-item-icon class="mx-0 my-0 py-4">
                <v-icon small>mdi-file-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Importado</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userIsAdmin || user.id_hexa === item.usuario_id" @click="openDialogTratativa(item.id, item.nome)">
              <v-list-item-icon class="mx-0 my-0 py-4">
                <v-icon small>mdi-file-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Tratar</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deleteFile(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Arquivo #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o arquivo
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>

    <dialog-tratativa :showDialog="dialogTratativa" :loading="loadingDialogTratativa" @changeValue="dialogTratativa = $event" @processar="processarTratativa">
      <template slot="title">
        Tratar o Arquivo
        <strong>{{ dialogTratativaData.titulo }}</strong>
      </template>
      <template slot="body">
        <v-row align="center" no-gutters class="mx-4">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                id="scripts"
                v-model="tratativa"
                item-text="nome"
                item-value="value"
                :error-messages="errors"
                label="Scripts Disponíveis"
                :items="tratativasList"
                outlined
                chips
                small-chips
                class="pb-0"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </template>
    </dialog-tratativa>
  </div>
</template>

<script>
  import ArquivosDadosService from '@/services/ArquivosDadosService.js';
  import TratativasArquivosService from '@/services/TratativasArquivosService.js';
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      DialogTratativa: () => import('@/components/arquivosDados/DialogTratativa')
    },

    mixins: [DateFormatterMixins],

    props: {
      items: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      downloadProgressData: {
        type: Object,
        required: true
      },
      active: {
        type: Array,
        required: true
      }
    },

    emits: ['update:items', 'update:downloadProgressData', 'rechargeUploadedFiles'],

    data() {
      return {
        headers: [
          {
            text: 'Nome do Arquivo',
            value: 'nome'
          },
          {
            text: 'Tamanho',
            value: 'size'
          },
          {
            text: 'Enviado por',
            value: 'enviado_por'
          },
          {
            text: 'Enviado em',
            value: 'created'
          },
          {
            text: 'Importado',
            value: 'importado'
          },
          {
            text: 'Ações',
            value: 'actions',
            sortable: false,
            class: 'pl-4'
          }
        ],
        search: '',
        dialogDeleteData: {},
        dialogDelete: false,

        tratativa: [],
        tratativasList: [],
        dialogTratativaData: {},
        dialogTratativa: false,
        loadingDialogTratativa: false
      };
    },

    computed: {
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      getDateFormattedCard() {
        return this.active.length ? this.formatMonth(this.active[0].substring(0, 10)) : '';
      },
      user() {
        return this.$store.getters.getUser;
      },
      selectedAno() {
        return this.active.length ? this.active[0].split('-')[0] : '';
      },
      selectedMes() {
        return this.active.length ? this.active[0].split('-')[1] : '';
      },
      selectedGroupId() {
        return this.active.length ? this.active[0].split('-')[2] : '';
      },
      _items: {
        get() {
          return this.items;
        },
        set(newValue) {
          this.$emit('update:items', newValue);
        }
      },
      _downloadProgressData: {
        get() {
          return this.downloadProgressData;
        },
        set(newValue) {
          this.$emit('update:downloadProgressData', newValue);
        }
      }
    },

    methods: {
      openDialogTratativa(itemId, itemTitle) {
        TratativasArquivosService.getAllTratativas()
          .then(({ data }) => {
            this.tratativasList = data.data
              .filter(item => item.nome !== 'hexa_cji3_imbo_composicao_process_tiggered')
              .map((item) => {
                return {
                  nome: item.nome,
                  value: item.dag_id
                };
              });
            this.dialogTratativaData = {
              arquivo_id: itemId,
              titulo: itemTitle
            };

            this.dialogTratativa = true;
          })
        .catch((err) => {
          console.error(err);
          this.$toast.error(`Erro ao buscar os scripts`, '', { position: 'topRight' });
          this.dialogTratativa = false;
        });
      },

      processarTratativa() {
        this.loadingDialogTratativa = true;

        TratativasArquivosService.processarTratativa(this.tratativa, this.dialogTratativaData)
          .then(() => {
            this.$toast.success('Processamento iniciado!');

            this.dialogTratativa = false;
            this.tratativa = [];
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao processar o script`, '', { position: 'topRight' });
          })
          .finally(() => {
            this.loadingDialogTratativa = false;
          });
      },

      openDialogDelete(itemId, itemTitle) {
        this.dialogDeleteData = { id: itemId, titulo: itemTitle };
        this.dialogDelete = true;
      },
      deleteFile(id) {
        ArquivosDadosService.excluir(id)
          .then(() => {
            this.$toast.success(`Arquivo excluído com sucesso`, '', { position: 'topRight' });
            this.$emit('rechargeUploadedFiles');
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao excluír arquivo`, '', { position: 'topRight' });
          });

        this.dialogDelete = false;
      },
      setImportado(id) {
        this.$toast.info(`Processando...`, '', { position: 'topRight' });
        ArquivosDadosService.setImportado(id)
          .then(() => {
            this.$toast.success(`Arquivo definido como importado.`, '', { position: 'topRight' });
            this.$emit('rechargeUploadedFiles');
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao definir arquivo como importado.`, '', { position: 'topRight' });
          });
      },
      downloadFile(item) {
        if (this._downloadProgressData[item.id] !== undefined) return;

        const id = item.id;

        this.$set(this._downloadProgressData, id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

        ArquivosDadosService.download(id, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;
            this.$set(this._downloadProgressData, id, { progress, isComputable, id });
          }
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.nome + '.zip');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao baixar arquivo '${item.nome}'.`, '', { position: 'topRight' });
          })
          .finally(() => {
            this.$delete(this._downloadProgressData, id);
          });
      }
    }
  };
</script>

<style>
  .style-table-arquivos-dados table thead tr th {
    font-weight: 400;
    font-size: 14px;
    height: 33px;
  }

  .style-table-arquivos-dados table tbody tr td {
    word-wrap: break-word;
    max-width: 240px;
    font-size: 12.5px;
    padding: 0px 8px !important;
    height: 45px;
  }

  .style-table-arquivos-dados table tbody tr td:nth-child(6) {
    white-space: nowrap !important;
  }

  @media screen and (max-width: 920px) {
    .style-table-arquivos-dados table tbody tr td {
      max-width: 100% !important;
    }
  }
</style>
